/*
 * offer-widget.js — version Helvia (thème Shrine)
 * Moteur des offres quantité (quantity break + 2 achetés 1 offert).
 *
 * Ce script N'APPLIQUE PAS de remise. Il affiche l'offre et déclare au thème
 * les lignes à ajouter au panier. La remise réelle doit venir d'une réduction
 * automatique Shopify (Admin > Réductions > Réduction automatique).
 *
 * Intégration : le widget s'expose comme <offer-widget id="quantity-breaks-{section.id}">
 * avec une propriété `formVariants` ([{id, quantity}, ...]). C'est exactement le
 * contrat que product-form.js du thème Shrine attend : il construit lui-même les
 * champs items[n][id] / items[n][quantity] et gère le loader + le tiroir panier.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ *
   * Utilitaires
   * ------------------------------------------------------------------ */

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents == null) cents = 0;
    var number = (cents / 100.0).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  // Reproduit le comportement du filtre `money` de Liquid à partir de
  // shop.money_format, au lieu d'écrire la devise en dur.
  function makeMoney(format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    return function (cents) {
      var match = format && format.match(placeholder);
      if (!match) return formatWithDelimiters(cents, 2, "'", '.');
      var value;
      switch (match[1]) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', ',');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
        default:
          value = formatWithDelimiters(cents, 2, ',', '.');
      }
      return format.replace(placeholder, value);
    };
  }

  function sizedImage(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  /* ------------------------------------------------------------------ *
   * Widget
   * ------------------------------------------------------------------ */

  function OfferWidget(wrap) {
    this.wrap = wrap;
    this.data = (window.__offerWidgetData || {})[wrap.id] || {};
    this.variants = this.data.variants || [];
    this.options = this.data.options || [];
    this.money = makeMoney(this.data.moneyFormat || "CHF {{amount_with_apostrophe_separator}}");

    this.basePrice = parseInt(wrap.dataset.basePrice, 10) || 0;
    this.freeShipThreshold = parseInt(wrap.dataset.freeShip, 10) || 0;
    this.multi = wrap.dataset.multiVariants === 'true';

    this.tiers = toArray(wrap.querySelectorAll('[data-tier]'));
    this.errorEl = wrap.querySelector('[data-offer-error]');

    // Le formulaire doit être celui de CE produit, pas le premier de la page
    // (une page peut contenir plusieurs product-form : quick add, produit mis
    // en avant, etc.).
    var scope = wrap.closest('product-info') || wrap.closest('.section') || document;
    this.productForm = scope.querySelector('product-form');
    this.form = this.productForm ? this.productForm.querySelector('form') : null;
    this.idInput = this.form ? this.form.querySelector('[name="id"]') : null;
    this.submitBtn = this.productForm ? this.productForm.querySelector('[type="submit"]') : null;

    this.bind();
    this.refresh();
  }

  OfferWidget.prototype.activeTier = function () {
    return this.wrap.querySelector('[data-tier].is-active') || this.tiers[0];
  };

  /* --- Résolution des variantes ------------------------------------- */

  OfferWidget.prototype.findVariant = function (values) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (String(v.options[j]) !== String(values[j])) { ok = false; break; }
      }
      if (ok) return v; // on renvoie même si indisponible, pour pouvoir l'annoncer
    }
    return null;
  };

  OfferWidget.prototype.rowVariant = function (row) {
    if (!this.multi) {
      return this.variants.length === 1
        ? this.variants[0]
        : this.findVariant(this.currentValues());
    }
    var values = toArray(row.querySelectorAll('.offer-select')).map(function (s) { return s.value; });
    return this.findVariant(values);
  };

  OfferWidget.prototype.currentValues = function () {
    var firstRow = this.wrap.querySelector('[data-row]');
    if (!firstRow) return [];
    return toArray(firstRow.querySelectorAll('.offer-select')).map(function (s) { return s.value; });
  };

  // Liste des lignes du palier actif, résolues en variantes.
  OfferWidget.prototype.lineItems = function () {
    var tier = this.activeTier();
    if (!tier) return [];
    var self = this;
    var items = [];

    if (this.multi) {
      toArray(tier.querySelectorAll('[data-row]')).forEach(function (row) {
        items.push({ row: row, variant: self.rowVariant(row), quantity: 1 });
      });
      return items;
    }

    var qty = this.tierQty(tier);
    var variant = this.variants.length ? this.variants[0] : null;
    if (this.variants.length > 1) variant = this.findVariant(this.currentValues());
    return [{ row: null, variant: variant, quantity: qty }];
  };

  OfferWidget.prototype.tierQty = function (tier) {
    if (this.multi) {
      var rows = tier.querySelectorAll('[data-row]');
      if (rows.length) return rows.length;
    }
    var stepper = tier.querySelector('[data-qty-input]');
    if (stepper) {
      var n = parseInt(stepper.value, 10);
      return isNaN(n) ? parseInt(tier.dataset.qty, 10) : n;
    }
    return parseInt(tier.dataset.qty, 10) || 1;
  };

  /* --- Calcul des prix ---------------------------------------------- */

  // Prix réel du palier, basé sur les variantes effectivement choisies
  // (les variantes peuvent avoir des prix différents).
  OfferWidget.prototype.tierPricing = function (tier) {
    var self = this;
    var perItemOff = parseInt(tier.dataset.perItemOff, 10) || 0;
    var freeItems = parseInt(tier.dataset.freeItems, 10) || 0;
    var qty = this.tierQty(tier);
    var prices = [];

    if (this.multi && tier.classList.contains('is-active')) {
      toArray(tier.querySelectorAll('[data-row]')).forEach(function (row) {
        var v = self.rowVariant(row);
        prices.push(v ? v.price : self.basePrice);
      });
    } else {
      for (var i = 0; i < qty; i++) prices.push(this.basePrice);
    }

    var total = prices.reduce(function (a, b) { return a + b; }, 0);

    // Les articles offerts sont les moins chers : c'est la règle appliquée
    // par les réductions automatiques "Achetez X obtenez Y" de Shopify.
    var giftAmount = 0;
    if (freeItems > 0) {
      var sorted = prices.slice().sort(function (a, b) { return a - b; });
      giftAmount = sorted.slice(0, freeItems).reduce(function (a, b) { return a + b; }, 0);
    }

    var discount = perItemOff * qty + giftAmount;
    var final = Math.max(0, total - discount);

    return { qty: qty, total: total, final: final, discount: discount };
  };

  OfferWidget.prototype.refreshPrices = function () {
    var self = this;
    this.tiers.forEach(function (tier) {
      var p = self.tierPricing(tier);
      var newEl = tier.querySelector('[data-price-new]');
      var oldEl = tier.querySelector('[data-price-old]');
      var qtyLabel = tier.querySelector('[data-qty-label]');
      var shipLabel = tier.querySelector('[data-free-ship-label]');

      if (newEl) newEl.textContent = self.money(p.final);
      if (oldEl) {
        // Ne barrer un prix que s'il y a vraiment une remise.
        oldEl.hidden = p.discount <= 0;
        oldEl.textContent = self.money(p.total);
      }
      if (qtyLabel && tier.dataset.allowMore === '1') {
        qtyLabel.textContent = p.qty + '+';
      }
      if (shipLabel) {
        shipLabel.hidden = !(self.freeShipThreshold > 0 && p.final >= self.freeShipThreshold);
      }
    });
  };

  /* --- Validation ---------------------------------------------------- */

  OfferWidget.prototype.validate = function () {
    var items = this.lineItems();
    var problem = null;

    for (var i = 0; i < items.length; i++) {
      if (!items[i].variant) {
        problem = 'Cette combinaison n’est pas disponible. Merci de choisir une autre option.';
        break;
      }
      if (!items[i].variant.available) {
        problem = '« ' + items[i].variant.title + ' » est en rupture de stock.';
        break;
      }
    }

    this.showError(problem);
    this.invalid = !!problem;
    if (this.submitBtn && !this.submitBtn.hasAttribute('data-unavailable')) {
      this.submitBtn.classList.toggle('offer-blocked', !!problem);
    }
    return !problem;
  };

  OfferWidget.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.hidden = !message;
    this.errorEl.textContent = message || '';
  };

  /* --- Contrat avec product-form.js ----------------------------------- */

  // Les lignes du palier actif, regroupées par variante.
  // C'est ce que le thème lit via `quantityBreaks.formVariants`.
  OfferWidget.prototype.groupedItems = function () {
    var map = {};
    var order = [];
    this.lineItems().forEach(function (it) {
      if (!it.variant) return;
      var id = it.variant.id;
      if (!map[id]) { map[id] = 0; order.push(id); }
      map[id] += it.quantity;
    });
    return order.map(function (id) { return { id: Number(id), quantity: map[id] }; });
  };

  // Garde le champ caché du thème cohérent avec la 1re variante choisie
  // (le thème le retire du FormData en mode multi-lignes, mais d'autres
  // fonctions du thème le lisent).
  OfferWidget.prototype.syncForm = function () {
    var items = this.lineItems();
    if (!items.length || !items[0].variant) return;
    if (this.idInput) {
      this.idInput.disabled = false;
      this.idInput.value = items[0].variant.id;
    }
  };

  /* --- Lignes dynamiques --------------------------------------------- */

  OfferWidget.prototype.renumber = function (container) {
    var rows = toArray(container.querySelectorAll('[data-row]'));
    var min = parseInt(container.dataset.minRows, 10) || 1;
    rows.forEach(function (row, i) {
      var num = row.querySelector('[data-row-num]');
      if (num && row.dataset.gift !== 'true') num.textContent = i + 1;
      var rm = row.querySelector('[data-remove-row]');
      // On ne peut retirer une ligne que si on reste au-dessus du minimum.
      if (rm) rm.hidden = rows.length <= min;
    });
  };

  OfferWidget.prototype.addRow = function (container) {
    var template = container.querySelector('[data-row]');
    if (!template) return;

    var row = template.cloneNode(true);
    row.removeAttribute('data-gift');
    var num = row.querySelector('[data-row-num]');
    if (num) num.classList.remove('offer-row__num--gift');

    // Les id/for clonés seraient dupliqués : on les régénère.
    toArray(row.querySelectorAll('.offer-select')).forEach(function (sel, i) {
      var uid = container.closest('[data-offer-widget]').id + '-new-' + Date.now() + '-' + i;
      var label = row.querySelector('label[for="' + sel.id + '"]');
      sel.id = uid;
      if (label) label.setAttribute('for', uid);
    });

    container.appendChild(row);
    this.renumber(container);
    this.refresh();
  };

  OfferWidget.prototype.removeRow = function (row) {
    var container = row.closest('[data-rows]');
    var min = parseInt(container.dataset.minRows, 10) || 1;
    if (container.querySelectorAll('[data-row]').length <= min) return;
    row.remove();
    this.renumber(container);
    this.refresh();
  };

  /* --- Rafraîchissement global --------------------------------------- */

  OfferWidget.prototype.refreshImages = function () {
    var self = this;
    toArray(this.wrap.querySelectorAll('[data-row]')).forEach(function (row) {
      var v = self.rowVariant(row);
      var img = row.querySelector('[data-row-img]');
      if (img && v && v.featured_image && v.featured_image.src) {
        img.src = sizedImage(v.featured_image.src, 80);
      }
    });
  };

  OfferWidget.prototype.refresh = function () {
    var self = this;
    toArray(this.wrap.querySelectorAll('[data-rows]')).forEach(function (c) { self.renumber(c); });
    this.refreshImages();
    this.refreshPrices();
    this.syncForm();
    this.validate();
  };

  OfferWidget.prototype.selectTier = function (tier) {
    this.tiers.forEach(function (t) {
      var active = t === tier;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    this.refresh();
  };

  /* --- Écouteurs ------------------------------------------------------ */

  OfferWidget.prototype.bind = function () {
    var self = this;

    this.tiers.forEach(function (tier) {
      var header = tier.querySelector('[data-tier-header]');
      if (header) header.addEventListener('click', function () { self.selectTier(tier); });
      tier.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          self.selectTier(tier);
        }
      });
    });

    // Délégation : couvre aussi les lignes ajoutées après coup.
    this.wrap.addEventListener('change', function (e) {
      if (!e.target.classList.contains('offer-select')) return;
      self.refresh();
    });

    this.wrap.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-add-row]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        self.addRow(addBtn.closest('.offer-opt__body').querySelector('[data-rows]'));
        return;
      }
      var rmBtn = e.target.closest('[data-remove-row]');
      if (rmBtn) {
        e.preventDefault();
        e.stopPropagation();
        self.removeRow(rmBtn.closest('[data-row]'));
        return;
      }
      var plus = e.target.closest('[data-qty-plus]');
      var minus = e.target.closest('[data-qty-minus]');
      if (plus || minus) {
        e.preventDefault();
        e.stopPropagation();
        var input = (plus || minus).parentElement.querySelector('[data-qty-input]');
        var min = parseInt(input.min, 10) || 1;
        var val = parseInt(input.value, 10) || min;
        input.value = Math.max(min, val + (plus ? 1 : -1));
        self.refresh();
        return;
      }
      // Un clic sur un select ne doit pas replier/changer le palier.
      if (e.target.closest('.offer-select')) e.stopPropagation();
    });

    if (!this.form) return;

    // Capture : on passe AVANT le gestionnaire du thème pour bloquer l'ajout
    // si la sélection n'est pas achetable. Sinon on le laisse faire tout le
    // travail (loader, erreurs, tiroir panier) à partir de `formVariants`.
    var captureTarget = this.productForm || this.form.parentNode || document;
    captureTarget.addEventListener(
      'submit',
      function (e) {
        if (e.target !== self.form) return;
        if (self.validate()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      true
    );
  };

  /* ------------------------------------------------------------------ *
   * Élément personnalisé — c'est lui que product-form.js interroge.
   * ------------------------------------------------------------------ */

  if (!customElements.get('offer-widget')) {
    customElements.define(
      'offer-widget',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.offerReady === 'true') return;
          this.dataset.offerReady = 'true';

          // Le <product-form> du thème est rendu APRÈS ce bloc dans la page.
          // On attend donc la fin du parsing avant de s'y accrocher.
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.boot.bind(this), { once: true });
          } else {
            this.boot();
          }
        }

        boot() {
          if (this.widget) return;
          try {
            this.widget = new OfferWidget(this);
          } catch (e) {
            console.error('[offer-widget] init failed', e);
          }
        }

        // Contrat attendu par product-form.js : [{ id, quantity }, ...]
        get formVariants() {
          if (!this.widget) return [];
          try {
            return this.widget.groupedItems();
          } catch (e) {
            console.error('[offer-widget]', e);
            return [];
          }
        }
      }
    );
  }
})();
